import { STATUS_META } from "@/lib/api";

export const StatusBadge = ({ status, testId }) => {
  const m = STATUS_META[status] || { label: status, cls: "bg-stone-100 text-stone-700" };
  return (
    <span data-testid={testId || `status-badge-${status}`} className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${m.cls}`}>
      {m.label}
    </span>
  );
};
